import { Check } from "lucide-react"

const PaymentMethodCard = ({ id, title, icon, description, selected, onClick }) => {
  return (
    <div
      className={`relative overflow-hidden rounded-xl p-3 cursor-pointer transition-all ${selected
        ? "border-blue-600 bg-blue-50 dark:bg-blue-900/20 dark:border-blue-500"
        : "bg-white dark:border-neutral-900 dark:bg-neutral-900 border border-neutral-200 dark:bg-neutral-800 hover:border-blue-300 dark:hover:border-blue-700"
        }`}
      onClick={() => onClick(id)}
    >
      <div className="flex items-center gap-3">
        <div
          className={`p-2 rounded-full ${selected
            ? "bg-blue-100 dark:bg-blue-800/40 text-blue-600 dark:text-blue-400"
            : "bg-neutral-100 dark:bg-neutral-700 text-neutral-500 dark:text-neutral-400"
            }`}
        >
          {icon}
        </div>
        <div className="flex-1">
          <h3
            className={`text-sm font-medium ${selected ? "text-blue-700 dark:text-blue-400" : "text-neutral-700 dark:text-neutral-300"
              }`}
          >
            {title}
          </h3>
          <p className="text-xs text-neutral-500 dark:text-neutral-400">{description}</p>
        </div>
        <div
          className={`w-4 h-4 rounded-full flex items-center justify-center ${selected ? "bg-blue-500" : "border border-neutral-300 dark:border-neutral-600"
            }`}
        >
          {selected && <Check size={10} className="text-white" />}
        </div>
      </div>
    </div>
  )
}

export default PaymentMethodCard
